
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Download } from "lucide-react";
import { downloadGuardsTemplate } from '../../services/excelService';
import { ProgressDisplay } from './ProgressDisplay';
import { UploadStats } from './types';

interface UploadFormProps {
  isUploading: boolean;
  progress: number;
  stats: UploadStats;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

export const UploadForm = ({ 
  isUploading, 
  progress, 
  stats, 
  onFileChange 
}: UploadFormProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="file-upload">Upload Excel File</Label>
        <div className="flex gap-2">
          <Input
            id="file-upload"
            type="file"
            accept=".xlsx,.xls"
            onChange={onFileChange}
            disabled={isUploading}
            className="flex-1"
          />
          <Button 
            variant="outline"
            onClick={downloadGuardsTemplate}
            className="flex items-center gap-2"
            disabled={isUploading}
          >
            <Download className="w-4 h-4" />
            Template
          </Button>
        </div>
      </div>
      
      {isUploading && (
        <ProgressDisplay 
          progress={progress} 
          stats={stats} 
        />
      )}
    </div>
  );
};
